import { BaseUserEndpoints } from './base';

export class Uploads extends BaseUserEndpoints {}
